/**
 * Design token values for colors used in JS/JSX.
 * These mirror the SCSS variables in app/styles/_variables.scss for consistency.
 * Use these when SCSS variables cannot be used (e.g. inline fill, style props).
 */
export const COLOR_BLUE = '#527284';
export const COLOR_SECONDARY_BLUE = '#234C69';
